// extracted by mini-css-extract-plugin
export default {"blockwrapper":"FO","header":"GO","name":"HO","columns":"IO","imagewrapper":"JO","addinfo":"KO","description":"LO","price":"MO","old":"NO","new":"OO","desc_d":"PO","infoblock":"QO","desc_m":"RO"};
    if(module.hot) {
      // 1713912566682
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  